import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import GroupIcon from '@mui/icons-material/Group';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StoreIcon from '@mui/icons-material/Store';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import PersonIcon from '@mui/icons-material/Person';

function ListaPessoas() {
  const navigate = useNavigate();

  // Opções de “Pessoa” com rota e ícone
  const opcoes = [
    {
      titulo: 'Fornecedor',
      rota: '/pessoa/fornecedor',
      icone: <StoreIcon sx={{ fontSize: 40 }} />
    },
    {
      titulo: 'Cliente',
      rota: '/pessoa/cliente',
      icone: <GroupIcon sx={{ fontSize: 40 }} />
    },
    {
      titulo: 'Vendedor',
      rota: '/pessoa/vendedor',
      icone: <AssignmentIndIcon sx={{ fontSize: 40 }} />
    },
    {
      titulo: 'Funcionário',
      rota: '/pessoa/funcionario',
      icone: <PersonIcon sx={{ fontSize: 40 }} />
    },
    {
      titulo: 'Transportadora',
      rota: '/pessoa/transportadora',
      icone: <LocalShippingIcon sx={{ fontSize: 40 }} />
    }
  ];

  const handleNavigate = (rota) => {
    navigate(rota);
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 4 } }}>
      {/* Título Principal */}
      <Typography variant="h4" align="center" gutterBottom>
        Selecione o Tipo de Pessoa
      </Typography>
      {/* Subtítulo explicativo */}
      <Typography variant="subtitle1" align="center" sx={{ mb: 2 }}>
        Clique em um dos cards para acessar a listagem correspondente.
      </Typography>
      <Divider sx={{ mb: 4 }} />

      {/* Grid para organizar as opções */}
      <Grid container spacing={3} justifyContent="center">
        {opcoes.map((opcao, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              variant="outlined"
              sx={{
                borderRadius: 2,
                boxShadow: 3,
                transition: 'transform 0.2s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)'
                }
              }}
            >
              <CardActionArea onClick={() => handleNavigate(opcao.rota)}>
                <CardContent sx={{ textAlign: 'center' }}>
                  {/* Ícone */}
                  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                    {opcao.icone}
                  </Box>
                  {/* Título */}
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {opcao.titulo}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ListaPessoas;
